import React, { useEffect } from 'react';
import { EventHubAttendeesPresentation } from './event-hub-attendees.presentation';
import { EventHubAttendeesViewModel } from './event-hub-attendees.viewmodel';

type EventHubAttendeesProps = {
    vm: EventHubAttendeesViewModel;
};

export const EventHubAttendees = ({ vm }: EventHubAttendeesProps): JSX.Element => {
    useEffect(() => {
        vm.fetchAttendees();
        vm.fetchCustomFields();

        return () => {
            vm.clearAttendees();
        };
    }, []);

    return <EventHubAttendeesPresentation vm={vm} />;
};
